import type { RouteObject } from "react-router-dom";
import { page } from "@/app/page";

export const homeRoutes: RouteObject[] = [
  { id: "home.hub", path: "/", element: page(() => import("@/screens/HubDashboard")) },
  { id: "home.reports", path: "/reports", element: page(() => import("@/screens/Reports")) },
  { id: "home.forms", path: "/forms/*", element: page(() => import("@/screens/Forms")) },
  { id: "home.profile", path: "/me/profile", element: page(() => import("@/screens/me/Profile")) },
  { id: "home.account", path: "/account", element: page(() => import("@/screens/Account")) },
  { id: "home.onboarding", path: "/onboarding", element: page(() => import("@/screens/Onboarding")) },
];
